<template>
    <main-content>
        <div class="shadow-sm rounded p-4">
            <create-form :form_data="form_data" :form_meta_data="form_meta_data" :on_submit="create"></create-form>
        </div>
    </main-content>
</template>

<script>
    import CreateForm from "./components/create-form";
    import mainContent from "@/components/main-content";
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletService} from "@/common/api.service";

    export default {
        components: {
            CreateForm,
            mainContent,
        },
        data() {
            return {
                form_data: {
                    wallet_title: '',
                    password: '',
                    access_ips: [''],
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.btn.create_wallet'),
                },
            };
        },
        methods: {
            create() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        wallet_title: {
                            required: true,
                        },
                        password: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let access_ips = [];

                for (let item of this.form_data.access_ips) {
                    if (item !== '' && item != null) {
                        access_ips.push(item);
                    }
                }

                let params = {
                    wallet_title: this.form_data.wallet_title,
                    wallet_prefix: 'A',
                    password: this.form_data.password,
                    access_ips: access_ips,
                };

                walletService.create(params).then(response => {
                    this.$router.push('/wallets');
                })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data);
                        }
                        this.showMsg(form, 'danger', response.data.message);
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    })
                    .finally(() => {
                        this.form_meta_data.submit_btn_progress = false;
                    });
            },
        },
    }
</script>
